module.exports = __webpack_public_path__ + "static/media/create.f385516b.svg";